import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const CandidateSkeleton = (props) => {
  return (
    <div className="recruiter-jpa-item">
      <SkeletonTheme color="#dde2eb" highlightColor="#f5f7fa">
        <Skeleton
          count={1}
          height={22}
          width={89}
          duration={0.8}
          style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            borderRadius: "20px",
          }}
        />
        <Skeleton
          count={1}
          height={72}
          width={72}
          circle={true}
          duration={0.8}
          style={{
            position: "absolute",
            top: "56px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        />
        <Skeleton
          count={1}
          height={26}
          width={113}
          duration={0.8}
          style={{
            position: "absolute",
            top: "140px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={26}
          width={113}
          duration={0.8}
          style={{
            position: "absolute",
            top: "175px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={40}
          width={170}
          duration={0.8}
          style={{
            position: "absolute",
            top: "220px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={2}
          width={"85%"}
          duration={0.8}
          style={{
            position: "absolute",
            top: "315px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={32}
          width={32}
          circle={true}
          duration={0.8}
          style={{
            position: "absolute",
            top: "300px",
            left: "24px",
          }}
        />
        <Skeleton
          count={1}
          height={20}
          width={50}
          duration={0.8}
          style={{
            position: "absolute",
            top: "345px",
            left: "16px",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={20}
          width={50}
          duration={0.8}
          style={{
            position: "absolute",
            top: "370px",
            left: "16px",
            borderRadius: "4px",
          }}
        />

        <Skeleton
          count={1}
          height={32}
          width={32}
          circle={true}
          duration={0.8}
          style={{
            position: "absolute",
            top: "300px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        />
        <Skeleton
          count={1}
          height={20}
          width={50}
          duration={0.8}
          style={{
            position: "absolute",
            top: "345px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={20}
          width={50}
          duration={0.8}
          style={{
            position: "absolute",
            top: "370px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "4px",
          }}
        />

        <Skeleton
          count={1}
          height={32}
          width={32}
          circle={true}
          duration={0.8}
          style={{
            position: "absolute",
            top: "300px",
            right: "24px",
          }}
        />
        <Skeleton
          count={1}
          height={20}
          width={50}
          duration={0.8}
          style={{
            position: "absolute",
            top: "345px",
            right: "16px",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          count={1}
          height={20}
          width={50}
          duration={0.8}
          style={{
            position: "absolute",
            top: "370px",
            right: "16px",
            borderRadius: "4px",
          }}
        />
      </SkeletonTheme>
      <section className="candidate-actions">
        <SkeletonTheme color="#dde2eb" highlightColor="#f5f7fa">
          <Skeleton
            count={1}
            height={34}
            width={272}
            duration={0.8}
            style={{
              position: "absolute",
              top: "16px",
              right: "16px",
              borderRadius: "20px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
        </SkeletonTheme>
      </section>
    </div>
  );
};

export default CandidateSkeleton;
